// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"to_a big_b big_bj","SubscribedPhotoblogs__link":"to_b big_a big_r"};